import { ethers } from 'ethers';
import { getState } from 'src/store';
import { UserRejectedSigningError } from 'src/types/errors';

// Contract ABIs
import RegistryABI from '../../contracts/abis/Registry.json';
import RegistrarABI from '../../contracts/abis/Registrar.json';
import ResolverABI from '../../contracts/abis/Resolver.json';
import TokenABI from '../../contracts/abis/Token.json';

export const handleError = (
  error: unknown,
  message = 'An unknown error occurred',
) => {
  try {
    if (error instanceof UserRejectedSigningError) {
      message = error.message;
    } else if (typeof error === 'object' && error !== null && 'data' in error) {
      const iRegistry = new ethers.Interface(RegistryABI);
      const iRegistrar = new ethers.Interface(RegistrarABI);
      const iResolver = new ethers.Interface(ResolverABI);
      const iToken = new ethers.Interface(TokenABI);

      const errorDescription = _parseError(
        [iRegistry, iRegistrar, iResolver, iToken],
        String((error as any).data),
      );
      if (errorDescription) {
        message = errorDescription.name;
      } else {
        console.error('Unparsed blockchain error:', error);
      }
    } else if (error instanceof Error) {
      message = error.message || message;
    } else if (typeof error === 'string') {
      message = error;
    } else {
      console.error('Unknown error format:', error);
      message = 'An unexpected error occurred.';
    }
  } catch (handlingError) {
    console.error('Error while handling the error:', handlingError);
    message = 'An error occurred while processing the error.';
  }

  getState().setLoadingText('');
  getState().setSnackbar({
    open: true,
    message: message,
    severity: 'error',
  });
};

// Helper functions
const _parseError = (
  parsers: any[],
  errorData: string,
): ethers.ErrorDescription | null => {
  for (const parser of parsers) {
    const result = parser.parseError(errorData);
    if (result) return result;
  }
  return null;
};
